import * as t from 'io-ts';

import {AnswerModel} from './answerModel';
import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RAnswerFolderDirty = t.readonly(
  t.type({
    id: t.Integer,
    namespace: t.string,
    name: t.string,
    url: t.string,
    parentFolderId: t.union([t.undefined, t.Integer]),
    folderPath: t.readonlyArray(t.Integer),
    numChildFolders: t.Integer,
    numChildAnswers: t.Integer,
    sortOrder: t.Integer,
    createdAt: t.Integer,
    updatedAt: t.Integer,
  }),
  'answerFolder',
);

/*
 * Type.
 */

export interface AnswerFolderModel extends t.TypeOf<typeof RAnswerFolderDirty> {}
export const RAnswerFolder = t.clean<AnswerFolderModel>(RAnswerFolderDirty as any);

export type AnswerOrFolderModel = AnswerFolderModel | AnswerModel;

export function isAnswerFolder(answerOrFolder: AnswerOrFolderModel): answerOrFolder is AnswerFolderModel {
  return 'folderPath' in answerOrFolder;
}

/*
 * IO methods.
 */

export function parseAnswerFolder(src: any): AnswerFolderModel {
  return {
    id: src.id,
    namespace: src.namespace,
    name: src.name,
    url: src.url,
    sortOrder: src.sort_order,
    parentFolderId: src.parent_folder_id || undefined,
    folderPath: src.folder_path,
    numChildFolders: src.num_folders,
    numChildAnswers: src.num_answers,
    createdAt: src.created_at,
    updatedAt: src.updated_at || src.created_at,
  };
}

/*
 * API type.
 */

export const ApiAnswerFolder = makeApiType('answerFolder', RAnswerFolder, parseAnswerFolder);
